import { RefObject, useEffect, useState } from 'react';
import { on, off } from 'react-use/lib/misc/util';

// kudos: https://usehooks.com/
export const useHoverDirty = (ref: RefObject<Element>, enabled = true) => {
  if (process.env.NODE_ENV === 'development') {
    if (typeof ref !== 'object' || typeof ref.current === 'undefined') {
      console.error('useHoverDirty expects a single ref argument.');
    }
  }

  const [value, setValue] = useState(false);

  useEffect(() => {
    const onMouseOver = () => setValue(true);
    const onMouseOut = () => setValue(false);

    if (enabled && ref && ref.current) {
      on(ref.current, 'mouseenter', onMouseOver);
      on(ref.current, 'mouseleave', onMouseOut);
    }

    // fixes react-hooks/exhaustive-deps warning about stale ref elements
    const { current } = ref;

    return () => {
      if (enabled && current) {
        off(current, 'mouseenter', onMouseOver);
        off(current, 'mouseleave', onMouseOut);
      }
    };
  }, [enabled, ref]);

  return value;
};
